import { memo } from "react";
import ECommerceSettingsStatusCassette from "../ECommerceSettingsStatusCassette";
import usePaymentMethods from "./usePaymentMethods";

const PaymentMethods = () => {
    const settings = usePaymentMethods();

    return (
        <ECommerceSettingsStatusCassette
            title='Payment Methods'
            settings={settings}
        />
    );
};

export default memo(PaymentMethods);
